import { useState } from "react";
import styles from "./TemplateSelectionScreen.module.css";

interface Props {
    src: string;
    alt: string;
    maxHeight?: number;
    enableZoom?: boolean;
    zoomScale?: number;
    objectFit?: "cover" | "contain";
}

export function LazyImageWithSkeleton({
    src,
    alt,
    maxHeight,
    enableZoom = false,
    zoomScale = 1.2,
    objectFit = "cover",
}: Props) {
    const [loaded, setLoaded] = useState(false);
    const [transformOrigin, setTransformOrigin] = useState("center center");
    const [beingHovered, setBeingHovered] = useState(false);

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!enableZoom) return;

        const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;
        setTransformOrigin(`${x}% ${y}%`);
    };

    const handleMouseLeave = () => {
        setBeingHovered(false);
        if (!enableZoom) return;
        setTransformOrigin("center center");
    };

    return (
        <div
            className={styles.imageWrapper}
            style={{
                ...(maxHeight ? { maxHeight: `${maxHeight}px` } : {}),
                height: loaded ? "auto" : "300px",
            }}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onMouseEnter={() => setBeingHovered(true)}
        >
            {!loaded && <div className={styles.imageSkeleton} />}

            <img
                src={src}
                alt={alt}
                style={{
                    objectFit: objectFit,
                    maxHeight,
                    width: "100%",
                    transformOrigin: transformOrigin,
                    transform: enableZoom && beingHovered ? `scale(${zoomScale})` : "none",
                    transition: "transform 0.5s ease-in-out",
                }}
                onLoad={() => setLoaded(true)}
            />
        </div>
    );
}
